module.exports = __webpack_public_path__ + "static/img/30.7447cac1.png";